import styled from 'styled-components';

export const Result = styled.div`
  margin-top: 1.23rem;
`;
